// we may want to change the output object such that each lap has it's own object with the lapnum

export function prepareAndUploadTelemetry(
  telemetry_metadata,
  telemetry_data,
  run_detail
) {
  // insert lap numbers
  function insertLapNumbers(telemetry_data_array) {
    const workingDataArray = telemetry_data_array;
    const lapIndexes = telemetry_metadata.LapArrayIndexes;
    let currLapIndex = 0;
    const arrayWithLapNums = workingDataArray.map((line, index) => {
      let newLine = [];
      if (index === 0) {
        newLine = ['LapNumber', ...line];
      } else {
        if (index < lapIndexes[currLapIndex]) {
          //index + 1 is the lap number starting at 1
          newLine = [String(currLapIndex + 1), ...line];
        }
        if (index === lapIndexes[currLapIndex]) {
          newLine = [String(currLapIndex + 1), ...line];
          currLapIndex++;
        }
      }
      return newLine;
    });
    //   .toSpliced(1, 3); //remove the random lines in the motec file (units, etc)
    return arrayWithLapNums;
  }
  //process the data array and put the resulting json file in state
  function formatDataToFile() {
    const workingDataArray = insertLapNumbers(telemetry_data);

    const [keyList, _redundantKeyList, _unitDefs, _metCount, ...valuesList] =
      workingDataArray;
    // console.log(keyList, _redundantKeyList, _unitDefs, _metCount);
    const result = valuesList.map((values) => {
      let obj = {};
      values.forEach((val, i) => {
        obj[keyList[i]] = val;
      });
      return obj;
    });

    const { eventId, runId, racerId } = run_detail;
    const finalFile = {
      metadata: {
        ...telemetry_metadata,
        EventDetails: { eventId, runId, racerId },
      },
      lapdata: [...result],
    };
    const jsonFile = JSON.stringify(finalFile);
    return jsonFile;
  }
  return formatDataToFile();
}
